import _ from 'lodash';
import REST from '../rest';
import { activeReport } from 'utils/report';

const ENDPOINT = 'api/v1/insights';

export const load = (props) => {
  const report = activeReport();
  const reportId = report ? report.id : null;
  
  const params = {
    ...props,
    include: 'reports',
  };

  if (reportId) {
    params.filter = {
      ...params.filter,
      report_id: reportId,
    };
  }

  return REST.get(
    ENDPOINT,
    _.get(props, 'id'),
    params,
  );
};

export const create = (reportId, data) => {
  const insightData = {
    data: {
      type: 'insights',
      attributes: {
        name: data.name,
        user_question: data.user_question,
        blacklisted_attributes: data.blacklisted_attributes,
        text_answers: data.text_answers,
        filters: data.filters,
      },
    },
  };

  return REST.post(`${ENDPOINT}?report_id=${reportId}`, insightData);
};

export const deleteInsight = (insightId) => {
  return REST.delete(`${ENDPOINT}/${insightId}`);
}; 